module.exports = __webpack_public_path__ + "static/media/ic_file_list.884bc1cd.png";